/*

Author: David Biga - All rights reserved - 2015

Description:  This is the core file that handles our camera object - canvas.js uses to render our camera posiion
*/
import THREE from 'particlespace-graphics-engine'

	// handles our rendering of all of our objects
var CameraHandler = Class.create({// variables: container => camera => scene => renderer => plane => mouse => raycaster => isShiftDown  => cubeGeometry => cubeMaterial => cubeTmpHoverMaterial => colorNormal => colorHover => colorTmpHover => colorRemove = >  blocks => tmpBlocks
  	initialize: function() {
		// setup local vars
		var onMouseDownPosition,onMouseDownTheta = 45,onMouseDownPhi = 60,radious = 1300,theta = 45,phi = 60;
		
		onMouseDownPosition = new THREE.Vector2();
		
		// #  Setup element sizes
		var width = window.innerWidth;
		var height = window.innerHeight;

		var camera = new THREE.PerspectiveCamera(40,width / height,1,10000);

		camera.position.set(500, 800, 1300);// 1st = swing (left or right) 2nd = up or down 3rd = zoom
		camera.lookAt( new THREE.Vector3());
		camera.positionID = 1;// default
		camera.positionType = 'sideView';// default
		
		this.onMouseDownPosition = onMouseDownPosition;
		this.onMouseDownTheta = onMouseDownTheta;
		this.onMouseDownPhi = onMouseDownPhi;
		this.radious = radious;
		this.theta = theta;
		this.phi = phi;
		this.cam = camera;
		
		// assign our camera vars
	},
	  updatePerspectiveCamera: function(){
		  if(this.cam.positionID == 1)
		  {
			  // #  DEPRECIATED
		  	// change our perspecive to birdeye
		 	 /*var camera = new THREE.PerspectiveCamera(  40, window.innerWidth / window.innerHeight, 1, 10000  );
			 camera.position.set( 0, 2000, 0  );// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			 camera.lookAt( new THREE.Vector3() );
			 camera.positionID = 2;
			 camera.positionType = 'birdView' 
			 this.cam = camera;*/
			 
			 this.cam.position.set( 0, 2000, 0  );// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			 this.cam.lookAt( new THREE.Vector3() );
			 this.cam.positionID = 2;
			 this.cam.positionType = 'birdView' 
		  }
		  else if(this.cam.positionID == 2)
		  {
			var x = this.radious * Math.sin( this.theta * Math.PI / 360 ) * Math.cos( this.phi * Math.PI / 360 );
			var y = this.radious * Math.sin( this.phi * Math.PI / 360 );
			var z = this.radious * Math.cos( this.theta * Math.PI / 360 ) * Math.cos( this.phi * Math.PI / 360 );	
			// #  DEPRECIATED
			/*// change our perspective to side
			var camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 10000  );
			camera.position.set( x, y, z  );// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			camera.lookAt( new THREE.Vector3() );
			camera.positionID = 1;
			camera.positionType = 'sideView'
			this.cam = camera;  */
			this.cam.position.set( x, y, z  );// 1st = swing (left or right) 2nd = up or down 3rd = zoom
			this.cam.lookAt( new THREE.Vector3() );
			this.cam.positionID = 1;
			this.cam.positionType = 'sideView'
		  }
	  },
	  reloadCamera: function(){
			return this;  
	  }
});

export let cameraHandler = new CameraHandler();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/CameraHandler.js